import React, {Component} from "react";
import CostAddComponent from "./helper_components/CostAddComponent";
import userDefaultPhoto from "../assets/img/default-user-image.png";
import userInformationBackground from "../assets/img/user-bg.png";
import ManagersComponent from "./ManagerComponent";
import { checkTokenUtil,onChangeDate } from "../utils";
import SumiagroCostAddComponent from "./CustomComponents/SumiagroCostAddComponent";

class CostEntryComponent extends Component{
  constructor(props){
    super(props);
    const {t} = props
    this.state = {
      sendToConfirmationValue:0,
      costFormComponents:[{
        component: (this.props.employeeInfo.permission.onMasrafFormuSumiagro === "true" ?
      <SumiagroCostAddComponent t={t} onChangeDate={onChangeDate} costNumber={1} parent={this} costTypes={props.costTypes} kdvOrani={props.kdvOrani} kdvOraniAktif={props.kdvOraniAktif} paymentType={this.props.employeeInfo.paymentType} costCategory={this.props.employeeInfo.costCategory} costLocation={this.props.employeeInfo.costLocation} costBrand={this.props.employeeInfo.costBrand}/> : 
      <CostAddComponent t={t} onChangeDate={onChangeDate} costNumber={1} parent={this} costTypes={props.costTypes} costDocumentationTypes={props.costDocumentationTypes} kdvOrani={props.kdvOrani} kdvOraniAktif={props.kdvOraniAktif} paymentType={this.props.employeeInfo.paymentType} costCategory={this.props.employeeInfo.costCategory} costLocation={this.props.employeeInfo.costLocation} costBrand={this.props.employeeInfo.costBrand}/>),
      
      refs:undefined,costPhotos:[]
    }],
      costNumber:1,
      updated:0
    };
    this.sendToConfirmation = this.sendToConfirmation.bind(this);
    this.incrementCostButton = this.incrementCostButton.bind(this);
    this.resetComponent = this.resetComponent.bind(this);
  }
  componentDidUpdate(prevProps,prevState){
    const result = checkTokenUtil()
    const {costTypes} = this.props;
    let {costFormComponents} = this.state;
    if(costTypes.length > 0 && costFormComponents.length !== prevState.costFormComponents.length){
        this.setState({
            updated:1,
            sendToConfirmationValue:0
        });
        this.updateCostNumber();
    }
    if( prevProps.t !== this.props.t  ){
      this.resetComponent(this.props.employeeInfo.permission.onMasrafFormuSumiagro)
    }
   if(prevProps.employeeInfo.permission.onMasrafFormuSumiagro !== this.props.employeeInfo.permission.onMasrafFormuSumiagro){
     this.resetComponent(this.props.employeeInfo.permission.onMasrafFormuSumiagro)
   }
  
  if(prevProps.kdvOrani && this.props.kdvOrani.length !== prevProps.kdvOrani.length){
      let newCostFormComponents = prevState.costFormComponents
      let newCostFormComponent = React.cloneElement(newCostFormComponents[0].component,{kdvOrani: this.props.kdvOrani})
      let newComponent = [{component: newCostFormComponent, refs: prevState.costFormComponents[0].refs,costPhotos: [] }]

      this.setState({costFormComponents : newComponent})
    }
    if(prevProps.employeeInfo.costBrand && this.props.employeeInfo.costBrand.length !== prevProps.employeeInfo.costBrand.length){
          let newCostFormComponents = prevState.costFormComponents
          let newCostFormComponent = React.cloneElement(newCostFormComponents[0].component,{costBrand: this.props.employeeInfo.costBrand})
          let newComponent = [{component: newCostFormComponent, refs: prevState.costFormComponents[0].refs,costPhotos: [] }]

          this.setState({costFormComponents : newComponent})
    }
    if(prevProps.employeeInfo.costLocation && this.props.employeeInfo.costLocation.length !== prevProps.employeeInfo.costLocation.length){
          let newCostFormComponents = prevState.costFormComponents
          let newCostFormComponent = React.cloneElement(newCostFormComponents[0].component,{costLocation: this.props.employeeInfo.costLocation})
          let newComponent = [{component: newCostFormComponent, refs: prevState.costFormComponents[0].refs,costPhotos: [] }]

          this.setState({costFormComponents : newComponent})
    }
      if(prevProps.employeeInfo.costCategory && this.props.employeeInfo.costCategory.length !== prevProps.employeeInfo.costCategory.length){
          let newCostFormComponents = prevState.costFormComponents
          let newCostFormComponent = React.cloneElement(newCostFormComponents[0].component,{costCategory: this.props.employeeInfo.costCategory})
          let newComponent = [{component: newCostFormComponent, refs: prevState.costFormComponents[0].refs,costPhotos: [] }]

          this.setState({costFormComponents : newComponent})
      }
      if( this.props.employeeInfo.kdvOraniAktif !== prevProps.employeeInfo.kdvOraniAktif){
          let newCostFormComponents = prevState.costFormComponents
          let newCostFormComponent = React.cloneElement(newCostFormComponents[0].component,{kdvOraniAktif: this.props.employeeInfo.kdvOraniAktif})
          let newComponent = [{component: newCostFormComponent, refs: prevState.costFormComponents[0].refs,costPhotos: [] }]

          this.setState({costFormComponents : newComponent})
      }


  }
  resetComponent(onMasrafFormuSumiagro){
    let {t} = this.props;
    const component= onMasrafFormuSumiagro === "true" ?
    <SumiagroCostAddComponent t={t} onChangeDate={onChangeDate} key={new Date()} costNumber={1} parent={this} costTypes={this.props.costTypes} kdvOrani={this.props.kdvOrani} kdvOraniAktif={this.props.kdvOraniAktif} paymentType={this.props.employeeInfo.paymentType} costCategory={this.props.employeeInfo.costCategory} costLocation={this.props.employeeInfo.costLocation} costBrand={this.props.employeeInfo.costBrand} />
    : <CostAddComponent t={t} onChangeDate={onChangeDate} key={new Date()} costNumber={1} parent={this} costTypes={this.props.costTypes} kdvOrani={this.props.kdvOrani} kdvOraniAktif={this.props.kdvOraniAktif} paymentType={this.props.employeeInfo.paymentType} costCategory={this.props.employeeInfo.costCategory} costLocation={this.props.employeeInfo.costLocation} costBrand={this.props.employeeInfo.costBrand} />
    this.setState({
      sendToConfirmationValue:0,
      costFormComponents:[{component:component,refs:undefined,costPhotos:[]}],
      costNumber:1
    });
  }
  sendToConfirmation(){
    if(this.state.sendToConfirmationValue === 1)
      this.setState({
        sendToConfirmationValue:0
      })
    else
      this.setState({
        sendToConfirmationValue:1
      })
  }
  incrementCostButton(onMasrafFormuSumiagro){
    var {costTypes,t} = this.props;
    this.state.costNumber ++;
    const costFormComponent = onMasrafFormuSumiagro === "true" ? 
    <SumiagroCostAddComponent t={t} onChangeDate={onChangeDate} parent={this} costNumber={this.state.costNumber} costTypes={costTypes} kdvOrani={this.props.kdvOrani} kdvOraniAktif={this.props.kdvOraniAktif} paymentType={this.props.employeeInfo.paymentType} costCategory={this.props.employeeInfo.costCategory} costLocation={this.props.employeeInfo.costLocation} costBrand={this.props.employeeInfo.costBrand}/> :
    <CostAddComponent t={t} onChangeDate={onChangeDate} parent={this} costNumber={this.state.costNumber} costTypes={costTypes} kdvOrani={this.props.kdvOrani} kdvOraniAktif={this.props.kdvOraniAktif} paymentType={this.props.employeeInfo.paymentType} costCategory={this.props.employeeInfo.costCategory} costLocation={this.props.employeeInfo.costLocation} costBrand={this.props.employeeInfo.costBrand}/>
  
    this.setState({
      costNumber: this.state.costNumber,
      costFormComponents: this.state.costFormComponents.concat({component:
      costFormComponent,refs:undefined,costPhotos:[]})
    });
  }
  updateCostNumber(){
    var index = 1;
    this.state.costFormComponents.forEach((comp) => {
      if(comp && comp.refs){
        comp.refs.cost_number.innerText = index;
        index ++;
      }
    });
  }
  render(){
    var {employeeInfo,managers,costAddButtonAction,permission, t} = this.props;
    var {sendToConfirmationValue,costFormComponents} = this.state;
    return  (
      <div className="content">
        <div className="container-fluid">
            <div className="row">
                <div className="col-lg-4 col-md-5">
                    <div className="card card-user">
                        <div className="image">
                            <img src={userInformationBackground}/>
                        </div>
                        <div className="content">
                            <div className="author" id="employee">
                              <img className="avatar border-white" id="employeeAvatar" src={employeeInfo.employeePhoto ? "data:image/png;base64,"+employeeInfo.employeePhoto : userDefaultPhoto}  alt="..."/>
                              <h4 className="title" id="employeeTitle">{employeeInfo.employeeName}<br />
                              </h4>
                            </div>
                            <p className="description text-center" id="employeeDescription">
                              {employeeInfo.unitName}
                            </p>
                        </div>
                        <hr />
                        <div className="text-center">
                          {
                            permission.addCost == "true" ?
                            <div className="row">
                                <div className="col-md-3 col-md-offset-1">
                                    <h5 id="employeeTotalCost">{employeeInfo.cost.total}<br /><small>{t('total')}</small></h5>
                                </div>
                                <div className="col-md-4">
                                    <h5 id="employeeApprovedCost">{employeeInfo.cost.approved}<br /><small>{t('approved')}</small></h5>
                                </div>
                                <div className="col-md-3">
                                    <h5 id="employeeWaitingCost">{employeeInfo.cost.waiting}<br /><small>{t('pendingCost')}</small></h5>
                                </div>
                            </div>
                            : null
                          }
                        </div>
                    </div>
                    {
                      permission.addCost == "true" ?
                        <div className="card">
                          <div className="header">
                              <h4 className="title" id="employeeManager">{t('yourManagers')}</h4>
                          </div>
                          <div className="content">
                            <ManagersComponent t={t} managerList={managers} userID={employeeInfo.uid}/>
                          </div>
                        </div>
                      : null
                    }
                </div>
                {
                  permission.addCost == "true" ?
                  <div className="col-lg-8 col-md-7">
                    <div className="costFormComponents">
                      {costFormComponents.map((comp,key) => {
                        return (comp !== null ? <div key={key}>{comp.component}</div> : null);
                      })}
                    </div>
                    <div className="col-xs-12 align-center increment-cost">
                      <button className="btn btn-wd actionBtn" id="incrementCostButton" onClick={() => this.incrementCostButton(permission.onMasrafFormuSumiagro)}><i className="fa fa-plus"></i></button>
                    </div>
                    <div className="col-xs-12 sendToConfirmationCheckBox card">
                      <div className="content">
                        <span><i onClick={this.sendToConfirmation} className={"fa " + (sendToConfirmationValue == 1 ? "fa-check-square-o" : "fa-square-o")}></i> {t('submitExpensesForApproval')}</span>
                      </div>
                    </div><br /><br />
                    <div className="more col-xs-12">
                      <button style={{width:"100%"}} id="costAddButton" onClick ={() => {
                           costAddButtonAction(costFormComponents,employeeInfo.accessToken,sendToConfirmationValue,() =>{this.resetComponent(permission.onMasrafFormuSumiagro)},{...employeeInfo,managers:managers})
                         }} className="btn btn-success btn-fill btn-wd"><i className="fa fa-save"></i> {t('saveCost')}</button>
                    </div>
                  </div>
                  : null
                }
            </div>
        </div>
    </div>
    );
  }
};

export default CostEntryComponent;
